import { render, staticRenderFns } from "./martyr-without-code.vue?vue&type=template&id=8bf53df2&"
import script from "./martyr-without-code.vue?vue&type=script&lang=js&"
export * from "./martyr-without-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports